import React from "react";
import {
  Button as HavenButton,
  ButtonProps as HavenButtonProps,
} from "components/haven-design/buttons";

type ButtonProps = React.HTMLProps<HTMLButtonElement> & {

  /**
   * Custom class names to be added
   */
  className?: string;

  /**
   * Is this the principal call to action on the page?
   */
  isPrimary?: boolean;
  isSelected?: boolean;
  isWide?: boolean;
  disabled?: boolean;
  type?: "submit" | "reset" | "button" | undefined;
}

export const HistoryBackButton: React.FC<Omit<HavenButtonProps, "color"> & {text?: string}> = (props) => <HavenButton
  type="button"
  size="S"
  color="secondary"
  onClick={() => history.back()}
  {...props}
>
  {props.text || "Back"}
</HavenButton>;
export type SubmitButtonProps = ButtonProps & {
  margin?: string;
  isInvalid?: boolean;
  isSaving?: boolean;
  text?: string;
  isLoading?: boolean;
  loadingText?: string;
}

export const SubmitButton: React.FC<SubmitButtonProps> = (props: SubmitButtonProps) => {
  const { isInvalid, isSaving, isLoading, loadingText, isWide, ...otherProps } = props;
  let { text } = props;
  if (isLoading) {
    text = loadingText;
  } else if (isInvalid) {
    text = "Please fill in required fields";
  } else if (isSaving) {
    text = "Saving...";
  } else {
    text = props.text || "Submit";
  }

  return (
    <HavenButton
      disabled={isLoading}
      {...otherProps}
      type="submit"
      size={isWide ? "L" : "S"}
      color="primary"
    >
      {text}
    </HavenButton>
  );
};
